module.exports = __webpack_public_path__ + "static/media/door00.45176e68.png";